export const codeSamples: Record<number, string> = {
  0: `/* main.c — CubeIDE 生成的 HAL 工程入口骨架 */
#include "main.h"

int main(void)
{
  HAL_Init();              // 初始化 HAL 与 SysTick
  SystemClock_Config();    // 本课程默认：HSE 8 MHz → SYSCLK 72 MHz
  MX_GPIO_Init();          // 初始化 CubeMX 生成的引脚配置

  while (1)
  {
    HAL_Delay(1000);       // 先在此行打断点，观察程序是否正常运行
  }
}`,
  1: `/* bit_ops.c — 32 位寄存器的读、改、写 */
#include <stdint.h>

#define BIT(n)              (1UL << (n))
#define FIELD_MASK(w, p)    (((1UL << (w)) - 1UL) << (p))

volatile uint32_t *reg = (uint32_t *)0x40021018UL;

void bit_demo(void)
{
  *reg |= BIT(2);                          // 置位：打开 IOPAEN
  *reg &= ~BIT(2);                         // 清零：关闭 IOPAEN
  uint32_t state = (*reg & BIT(2)) >> 2;   // 读取并归一化为 0/1
  (void)state;
}`,
  2: `/* system_clock.c — F103 常用的 72 MHz 配置 */
void SystemClock_Config(void)
{
  RCC_OscInitTypeDef osc = {0};
  RCC_ClkInitTypeDef clk = {0};

  osc.OscillatorType = RCC_OSCILLATORTYPE_HSE;
  osc.HSEState = RCC_HSE_ON;               // 板载 8 MHz 晶振
  osc.PLL.PLLState = RCC_PLL_ON;
  osc.PLL.PLLSource = RCC_PLLSOURCE_HSE;
  osc.PLL.PLLMUL = RCC_PLL_MUL9;            // 8 × 9 = 72 MHz
  HAL_RCC_OscConfig(&osc);

  clk.SYSCLKSource = RCC_SYSCLKSOURCE_PLLCLK;
  clk.AHBCLKDivider = RCC_SYSCLK_DIV1;      // HCLK = 72 MHz
  clk.APB1CLKDivider = RCC_HCLK_DIV2;       // PCLK1 = 36 MHz（上限）
  clk.APB2CLKDivider = RCC_HCLK_DIV1;       // PCLK2 = 72 MHz
  HAL_RCC_ClockConfig(&clk, FLASH_LATENCY_2);
}`,
  3: `/* main.c — PC13 低电平点亮的常见板载 LED */
HAL_GPIO_WritePin(GPIOC, GPIO_PIN_13, GPIO_PIN_RESET); // 点亮
HAL_Delay(500);
HAL_GPIO_WritePin(GPIOC, GPIO_PIN_13, GPIO_PIN_SET);   // 熄灭
HAL_Delay(500);

/* 等价的循环写法 */
while (1)
{
  HAL_GPIO_TogglePin(GPIOC, GPIO_PIN_13);
  HAL_Delay(500);
}`,
  4: `/* stm32f1xx_it.c + main.c — 中断只记录事件 */
volatile uint8_t button_event = 0;
volatile uint32_t last_tick = 0;

void HAL_GPIO_EXTI_Callback(uint16_t pin)
{
  uint32_t now = HAL_GetTick();
  if (pin == GPIO_PIN_0 && (now - last_tick) >= 20U) {
    button_event = 1;       // ISR 内不延时、不 printf
    last_tick = now;
  }
}

/* 主循环处理耗时工作 */
if (button_event) {
  button_event = 0;
  HAL_GPIO_TogglePin(GPIOC, GPIO_PIN_13);
}`,
  5: `/* TIM2 CH1 PWM：72 MHz 定时器时钟，1 kHz，25% 占空比 */
/* PSC=71 → 1 MHz 计数；ARR=999 → 1 kHz 更新 */
HAL_TIM_PWM_Start(&htim2, TIM_CHANNEL_1);

__HAL_TIM_SET_PRESCALER(&htim2, 71);
__HAL_TIM_SET_AUTORELOAD(&htim2, 999);
__HAL_TIM_SET_COMPARE(&htim2, TIM_CHANNEL_1, 250);

/* 频率 = 72 MHz / (PSC+1) / (ARR+1)
   占空比 ≈ CCR / (ARR+1) = 25% */`,
  6: `/* ADC1 CH0(PA0) + DMA，3.3 V 参考，12 位 */
#define ADC_COUNT 16
uint16_t adc_buffer[ADC_COUNT];

HAL_ADCEx_Calibration_Start(&hadc1); // F1 上电后先校准
HAL_ADC_Start_DMA(&hadc1, (uint32_t *)adc_buffer, ADC_COUNT);

float adc_average_voltage(void)
{
  uint32_t sum = 0;
  for (uint8_t i = 0; i < ADC_COUNT; ++i) sum += adc_buffer[i];
  float raw = (float)sum / ADC_COUNT;
  return raw * 3.3f / 4095.0f;
}`,
  7: `/* USART1：PA9 TX / PA10 RX，115200-8-N-1 */
static uint8_t rx_byte;

int _write(int file, char *ptr, int len)
{
  (void)file;
  HAL_UART_Transmit(&huart1, (uint8_t *)ptr, len, 100);
  return len;
}

void uart_begin(void)
{
  HAL_UART_Receive_IT(&huart1, &rx_byte, 1);
}

void HAL_UART_RxCpltCallback(UART_HandleTypeDef *huart)
{
  if (huart->Instance == USART1) {
    ring_buffer_push_from_isr(rx_byte); // 快速入队
    HAL_UART_Receive_IT(&huart1, &rx_byte, 1);
  }
}`,
  8: `/* I²C 读寄存器：地址必须确认是 7 位还是已左移 */
uint8_t value;
HAL_I2C_Mem_Read(&hi2c1,
                 SENSOR_ADDR_7BIT << 1,
                 REG_WHO_AM_I,
                 I2C_MEMADD_SIZE_8BIT,
                 &value, 1, 100);

/* SPI 全双工读写：CS 由普通 GPIO 管理 */
HAL_GPIO_WritePin(SPI_CS_GPIO_Port, SPI_CS_Pin, GPIO_PIN_RESET);
HAL_SPI_TransmitReceive(&hspi1, tx, rx, length, 100);
HAL_GPIO_WritePin(SPI_CS_GPIO_Port, SPI_CS_Pin, GPIO_PIN_SET);`,
  9: `/* IWDG：LSI 约 40 kHz，实际偏差较大，应留裕量 */
HAL_IWDG_Refresh(&hiwdg);

/* 进入停止模式前清理唤醒标志，唤醒后重配系统时钟 */
__HAL_PWR_CLEAR_FLAG(PWR_FLAG_WU);
HAL_SuspendTick();
HAL_PWR_EnterSTOPMode(PWR_LOWPOWERREGULATOR_ON, PWR_STOPENTRY_WFI);
SystemClock_Config();       // STOP 唤醒后 PLL/系统时钟需恢复
HAL_ResumeTick();`,
  10: `/* FreeRTOS：任务函数不能返回，延时使用调度器节拍 */
void LedTask(void *argument)
{
  (void)argument;
  for (;;) {
    HAL_GPIO_TogglePin(GPIOC, GPIO_PIN_13);
    osDelay(500);           // 阻塞当前任务，让出 CPU
  }
}

void SensorTask(void *argument)
{
  SensorMessage msg;
  for (;;) {
    msg.value = read_sensor();
    osMessageQueuePut(sensorQueueHandle, &msg, 0, 0);
    osDelay(100);
  }
}`,
  11: `/* HardFault 定位辅助：调试版保留栈帧与错误状态寄存器 */
void HardFault_Handler(void)
{
  volatile uint32_t hfsr = SCB->HFSR;
  volatile uint32_t cfsr = SCB->CFSR;
  volatile uint32_t bfar = SCB->BFAR;
  volatile uint32_t mmfar = SCB->MMFAR;
  (void)hfsr; (void)cfsr; (void)bfar; (void)mmfar;

  __BKPT(0);                // 连接调试器时停在这里
  while (1) { }
}`,
  12: `/* 项目 1 消息分发骨架：按键事件与串口命令统一处理 */
typedef enum { EVT_BUTTON, EVT_UART_COMMAND } EventType;
typedef struct { EventType type; uint8_t data; } AppEvent;

static void App_HandleEvent(const AppEvent *event)
{
  switch (event->type) {
    case EVT_BUTTON:
      HAL_GPIO_TogglePin(GPIOC, GPIO_PIN_13);
      printf("LED toggled by button\\r\\n");
      break;
    case EVT_UART_COMMAND:
      if (event->data == '1') HAL_GPIO_WritePin(GPIOC, GPIO_PIN_13, GPIO_PIN_RESET);
      if (event->data == '0') HAL_GPIO_WritePin(GPIOC, GPIO_PIN_13, GPIO_PIN_SET);
      break;
  }
}`,
};
